var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title",on:{"click":_vm.gotoPersonalInformation}},[_c('p',[_vm._v("个人资料")]),_vm._v(" "),_c('i',{staticClass:"el-icon-arrow-right",staticStyle:{"margin-top":"2px","margin-left":"10px"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-776b6704","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wx-member/points-mall/page-mail-my/views/my-set-up/my-set-up.vue
// module id = null
// module chunks = 